import StatefulArray from 'ember-data-model-fragments/array/stateful';

// ember-data-model-fragments' StatefulArray is `EmberObject.extend(MutableArray)`
// — a real MutableArray mixin (so `pushObject`/`removeAt`/`insertAt`/`objectAt`
// all exist and correctly maintain dirty-tracking/reactivity), but not a real
// Array, so it has no native `.push()`/`.splice()`. Code that treats it like a
// plain array (easy to do by accident - see fragment-array-iterable.js for the
// same story with iteration) throws "x.push is not a function" instead.
//
// FragmentArray extends StatefulArray, so patching the base covers both.
//
// TEMPORARY: delete this initializer (and its app/ re-export) once fragments
// are gone — WarpDrive's collections are native-array based. The `todo`s in
// tests/unit/initializers/fragment-array-mutable-test.js report the moment
// upstream ships these, so CI tells you when it is safe to remove.
export function initialize() {
  if (!StatefulArray.prototype.push) {
    StatefulArray.prototype.push = function (...items) {
      for (let item of items) {
        // eslint-disable-next-line no-restricted-properties -- `this` is a genuine EmberArray (StatefulArray), not a plain array
        this.pushObject(item);
      }
      return this.length;
    };
  }

  if (!StatefulArray.prototype.splice) {
    StatefulArray.prototype.splice = function (start, deleteCount, ...items) {
      let len = this.length;
      start = start < 0 ? Math.max(len + start, 0) : Math.min(start, len);
      deleteCount =
        deleteCount === undefined
          ? len - start
          : Math.max(0, Math.min(deleteCount, len - start));

      // `replace()` (below) can reuse a fragment instance in place at an
      // overlapping index rather than swapping in a new one, so a captured
      // reference would reflect the post-replace state, not what was
      // actually removed. `.copy()` snapshots each fragment independently
      // first, matching native splice's "removed items are frozen" contract.
      let removed = [];
      for (let i = 0; i < deleteCount; i++) {
        // eslint-disable-next-line no-restricted-properties -- `this` is a genuine EmberArray (StatefulArray), not a plain array
        removed.push(this.objectAt(start + i).copy());
      }

      // `replace()` is MutableArray's own foundational primitive - insertAt/
      // removeAt/pushObject are all implemented in terms of it. Doing the
      // remove and insert as one `replace()` call (rather than interleaved
      // removeAt/insertAt calls) is what makes this atomic and correct.
      this.replace(start, deleteCount, items);

      return removed;
    };
  }
}

export default {
  name: 'fragment-array-mutable',
  initialize,
};
